const getDefaultDriverHelpersState = () => {
  return {
    allDriverHelpers: [],
  }
}

export default getDefaultDriverHelpersState()
export { getDefaultDriverHelpersState }
